import { ReceivedVouches } from '../../../components/Vouch/ReceivedVouches';
import { useReceivedVouches } from '../../../hooks/useReceivedVouches';
import { VOUCH_COPY } from '../vouch.copy';
import './VouchReceivedSection.scss';

export function VouchReceivedSection() {
  const enabled = import.meta.env.VITE_ENABLE_VOUCHING === 'true';
  const { received } = useReceivedVouches();
  if (!enabled) return null;
  return (
    <section className="vouch-received">
      <h2 className="vouch-received__heading">{VOUCH_COPY.receivedHeading}</h2>
      {received.length > 0 ? (
        <>
          <p className="vouch-received__lead">
            {VOUCH_COPY.receivedLead(received.length)}
          </p>
          <ReceivedVouches />
          <p className="vouch-received__grow">{VOUCH_COPY.receivedGrow}</p>
        </>
      ) : (
        <p className="vouch-received__empty">{VOUCH_COPY.receivedEmpty}</p>
      )}
    </section>
  );
}
